import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetooutstationtempotraveller() {



    const cardData = {

keyword: "Pune to Outstation Tempo Traveller",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Outstation Tempo Traveller services for family trips, corporate tours, weddings, school excursions, pilgrimage journeys, and long-distance travel across India. We provide well-maintained 9, 12, 15, and 17-seater Tempo Travellers with push-back seats, air conditioning, ample luggage space, and experienced drivers for smooth highway travel. With doorstep pickup from Pune, flexible one-way and round-trip options, 24/7 support, and transparent pricing, we ensure a hassle-free group travel experience for all outstation destinations.",

topPlaces: [
    {
        title: "Goa Beach Circuit",
        description:
            "Goa is one of the most popular outstation destinations from Pune, known for its beaches, nightlife, adventure sports, and coastal drives. Tempo Travellers are ideal for group vacations, friends’ trips, and corporate tours, offering comfortable long-distance travel for a fun-filled holiday experience."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba, attracting devotees from across India. Group travel in Tempo Travellers is ideal for family darshan trips, offering comfort and convenience for spiritual journeys from Pune."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a spiritual and cultural hub known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. It is a popular outstation route for group religious tours, family trips, and leisure travel using Tempo Traveller rentals from Pune."
    },
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool climate. It is ideal for group vacations, school trips, and corporate outings, making Tempo Traveller travel comfortable and enjoyable."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the closest hill stations to Pune, famous for monsoon greenery, waterfalls, and scenic viewpoints. They are perfect for short group trips and weekend getaways using Tempo Traveller rentals."
    },
    {
        title: "Ashtavinayak Darshan Route",
        description:
            "The Ashtavinayak pilgrimage circuit includes eight sacred Ganpati temples across Maharashtra. Tempo Travellers are widely used for group spiritual tours, offering comfort and coordinated travel for family religious journeys."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular group pilgrimage destination where Tempo Travellers provide safe and comfortable travel for devotees."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. It is ideal for group outings, corporate trips, and family picnics using Tempo Traveller rentals from Pune."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. It is a top outstation heritage destination for group tours, educational trips, and cultural travel from Pune."
    },
    {
        title: "Konkan Coastal Tour",
        description:
            "The Konkan coast including destinations like Ganpatipule, Diveagar, Harihareshwar, and Tarkarli is a scenic travel region. Tempo Travellers are ideal for long group vacations with comfortable highway and coastal driving experiences."
    }
],



services: [
{
name: "Tempo Traveller Pune Rent",
description: "Rising Cab Service offers Tempo Traveller Pune Rent for local and outstation group travel with comfortable seating, AC vehicles, professional drivers, and affordable pricing. Ideal for family trips, corporate tours, weddings, and weekend getaways with flexible booking options."
},
{
name: "Pune Tempo Traveller Hire for Outstation",
description: "Book Pune Tempo Traveller Hire for Outstation travel to any destination including Goa, Shirdi, Mahabaleshwar, and more. Enjoy safe long-distance travel with experienced drivers, spacious seating, luggage capacity, and well-maintained vehicles."
},
{
name: "Pune to Outstation Tempo Traveller",
description: "Rising Cab Service provides Pune to Outstation Tempo Traveller for comfortable group journeys across India. Perfect for long tours with AC comfort, push-back seats, and professional chauffeurs ensuring safe highway travel."
},
{
name: "Pune to Goa Tempo Traveller",
description: "Book Pune to Goa Tempo Traveller for a fun and comfortable group beach trip. Enjoy smooth highway travel, AC comfort, and safe driving with experienced drivers for family and group vacations."
},
{
name: "Pune to Kolhapur Tempo Traveller Rent",
description: "Rising Cab Service offers Pune to Kolhapur Tempo Traveller Rent for pilgrimage and family travel. Ideal for Mahalaxmi temple visits and group tours with safe and comfortable transportation."
},
{
name: "Pune to Nashik Tempo Traveller Rent",
description: "Book Pune to Nashik Tempo Traveller Rent for religious trips, vineyard tours, and family outings. Enjoy spacious seating, AC comfort, and reliable drivers for a smooth journey."
},
{
name: "Pune to Mumbai Tempo Traveller Rent",
description: "Rising Cab Service provides Pune to Mumbai Tempo Traveller Rent for corporate travel, airport transfers, and group trips with comfortable seating and punctual service."
},
{
name: "Pune to Pandharpur Tempo Traveller Fare",
description: "Get transparent Pune to Pandharpur Tempo Traveller Fare with affordable per km pricing and flexible packages for pilgrimage group travel to Vitthal Rukmini temple."
},
{
name: "Pune Mumbai Airport Drop Tempo Traveller on Rent",
description: "Book Pune Mumbai Airport Drop Tempo Traveller on Rent for large group airport transfers with timely pickup, luggage space, and comfortable AC travel."
},
{
name: "Tempo Traveller on Rent for Wedding in Pune",
description: "Rising Cab Service offers Tempo Traveller on Rent for Wedding in Pune for guest transportation, ensuring smooth coordination, punctual service, and comfortable group travel."
},
{
name: "17 Seater Tempo Traveller for Outstation in Pune",
description: "Book 17 Seater Tempo Traveller for Outstation in Pune for large group tours with spacious seating, AC comfort, and experienced drivers for safe long-distance travel."
},
{
name: "Luxury Tempo Traveller on Rent in Pune",
description: "Rising Cab Service provides Luxury Tempo Traveller on Rent in Pune with premium interiors, push-back seats, LED entertainment, and professional chauffeurs for high-end group travel."
},
{
name: "Outstation Tempo Traveller for Picnic on Rent in Pune",
description: "Book Outstation Tempo Traveller for Picnic on Rent in Pune for family outings, hill station trips, and weekend getaways with safe and comfortable travel arrangements."
},
{
name: "Pune to Outstation Tempo Traveller Rate",
description: "Get Pune to Outstation Tempo Traveller Rate with transparent per km pricing, affordable packages, and no hidden charges for all long-distance group travel."
},
{
name: "Tempo Traveller on Rent in Pune",
description: "Rising Cab Service offers Tempo Traveller on Rent in Pune for all types of group travel including local trips, outstation tours, weddings, and corporate events."
},
{
name: "Pune Outstation Tempo Traveller Booking",
description: "Book Pune Outstation Tempo Traveller Booking instantly with flexible vehicle options, easy online reservation, and reliable service for all destinations."
},
{
name: "Luxury Tempo Traveller Pune",
description: "Book Luxury Tempo Traveller Pune for premium group travel experience with AC comfort, push-back seats, entertainment system, and professional drivers."
},
{
name: "17 Seater Tempo Traveller Pune",
description: "Rising Cab Service provides 17 Seater Tempo Traveller Pune for large group travel with comfort, safety, and spacious seating for all occasions."
},
{
name: "13 Seater Tempo Traveller on Rent Pune",
description: "Book 13 Seater Tempo Traveller on Rent Pune for small group travel with affordable pricing, AC comfort, and reliable service for family and corporate trips."
},
{
name: "Tempo Traveller for Family Trip Pune",
description: "Rising Cab Service offers Tempo Traveller for Family Trip Pune with safe driving, comfortable seating, and flexible travel plans for memorable vacations."
},
{
name: "AC Tempo Traveller on Rent Pune",
description: "Book AC Tempo Traveller on Rent Pune for cool and comfortable travel in all weather conditions with well-maintained vehicles and professional drivers."
},
{
name: "Cheap Tempo Traveller Pune",
description: "Get Cheap Tempo Traveller Pune with affordable pricing, quality service, and safe travel options without compromising comfort and reliability."
}
],

tableData: [
["Tempo Traveller Pune Rent","Pune Tempo Traveller Hire for Outstation"],
["Pune to Outstation Tempo Traveller","Pune to Goa Tempo Traveller"],
["Pune to Kolhapur Tempo Traveller Rent","Pune to Nashik Tempo Traveller Rent"],
["Pune to Mumbai Tempo Traveller Rent","Pune to Pandharpur Tempo Traveller Fare"],
["Pune Mumbai Airport Drop Tempo Traveller on Rent","Tempo Traveller on Rent for Wedding in Pune"],
["17 Seater Tempo Traveller for Outstation in Pune","Luxury Tempo Traveller on Rent in Pune"],
["Outstation Tempo Traveller for Picnic on Rent in Pune","Pune to Outstation Tempo Traveller Rate"],
["Tempo Traveller on Rent in Pune","Pune Outstation Tempo Traveller Booking"],
["Luxury Tempo Traveller Pune","17 Seater Tempo Traveller Pune"],
["13 Seater Tempo Traveller on Rent Pune","AC Tempo Traveller on Rent Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Outstation Tempo Traveller Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Tempo Traveller rentals from Pune for outstation trips, family vacations, corporate tours, pilgrimage journeys, and group travel."
    },
    {
        WhyChooseheading: "Perfect for Group Travel and Long Journeys",
        WhyChoosedescription: "Tempo Travellers are ideal for large families, friends, corporate teams, school groups, wedding guests, and tourist groups traveling together."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options Available",
        WhyChoosedescription: "Choose from 12 Seater, 14 Seater, 17 Seater, 20 Seater, and luxury Tempo Traveller options according to your group size and travel needs."
    },
    {
        WhyChooseheading: "Outstation Travel Across Maharashtra and India",
        WhyChoosedescription: "Our Tempo Travellers are available for destinations including Goa, Shirdi, Mahabaleshwar, Lonavala, Nashik, Kolhapur, Konkan, Hyderabad, Bangalore, Ujjain, and many more."
    },
    {
        WhyChooseheading: "AC Tempo Travellers for Comfortable Travel",
        WhyChoosedescription: "Well-maintained air-conditioned Tempo Travellers offer comfortable seating, spacious interiors, ample luggage space, and a pleasant travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Tempo Traveller pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our professional drivers are experienced in long-distance routes and ensure safe, smooth, and comfortable travel throughout the journey."
    },
    {
        WhyChooseheading: "Customized Tour and Travel Packages",
        WhyChoosedescription: "Customers can choose one-way trips, round-trip packages, weekend tours, pilgrimage packages, sightseeing tours, and multi-day travel plans."
    }
]
};

const faqData = [
    {
        question: "What is Pune to Outstation Tempo Traveller Service?",
        answer: "It is a group travel service that provides Tempo Travellers from Pune for outstation destinations, tours, pilgrimages, vacations, and corporate trips."
    },
    {
        question: "Which Tempo Traveller seating capacities are available?",
        answer: "We provide 12 Seater, 14 Seater, 17 Seater, 20 Seater, and luxury Tempo Traveller options."
    },
    {
        question: "Which destinations can be covered with outstation Tempo Traveller service?",
        answer: "Popular destinations include Goa, Shirdi, Mahabaleshwar, Lonavala, Nashik, Kolhapur, Konkan, Ujjain, Hyderabad, Bangalore, and other cities."
    },
    {
        question: "Are AC Tempo Travellers available for outstation travel?",
        answer: "Yes, fully air-conditioned Tempo Travellers are available for comfortable long-distance journeys."
    },
    {
        question: "Can families hire a Tempo Traveller for vacations?",
        answer: "Yes, Tempo Travellers are one of the most preferred options for family holidays, group tours, and sightseeing trips."
    },
    {
        question: "Do you provide Tempo Travellers for pilgrimage tours?",
        answer: "Yes, we provide vehicles for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Can corporate groups hire Tempo Travellers?",
        answer: "Yes, companies regularly hire Tempo Travellers for employee outings, conferences, industrial visits, and team events."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round-trip journeys, and customized travel packages."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, Tempo Traveller pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Outstation Tempo Traveller?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amit Shinde",
        feedback:
            "We hired a Tempo Traveller for our Goa group tour from Pune. The vehicle was spacious, comfortable, and made the entire journey enjoyable for everyone.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Patil",
        feedback:
            "Our family pilgrimage covering Shirdi and Nashik was perfectly managed. The Tempo Traveller was clean, comfortable, and ideal for long-distance group travel.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Outstation Tempo Traveller Service",
"image": "https://www.risingcabservice.com/assets/images/pune-outstation-tempo-traveller.jpg",
"description": "Book Pune Outstation Tempo Traveller Service with Rising Cab Service for safe and comfortable group travel. Ideal for outstation trips to Goa, Mumbai, Nashik, Kolhapur, Pandharpur, weddings, and corporate tours with AC luxury tempo travellers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹24/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-outstation-tempo-traveller"
}
};





    return (
        <div>
<Helmet>
  <title>Pune Outstation Tempo Traveller | Group Travel & Tours | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Outstation Tempo Traveller for group travel, weddings, corporate tours, and outstation trips. Get AC 17 seater and luxury tempo travellers for Goa, Mumbai, Nashik, Kolhapur, and more."
/>

<meta
 name="keywords"
 content="tempo traveller pune rent, pune tempo traveller hire for outstation, pune to outstation tempo traveller, pune to goa tempo traveller, pune to kolhapur tempo traveller rent, pune to nashik tempo traveller rent, pune to mumbai tempo traveller rent, pune to pandharpur tempo traveller fare, mumbai airport drop tempo traveller pune, tempo traveller on rent for wedding in pune, 17 seater tempo traveller for outstation in pune, luxury tempo traveller on rent in pune, outstation tempo traveller for picnic on rent in pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetooutstationtempotraveller;